const standardOnEnd = script =>
  new Promise((resolve, reject) => {
    script.onload = function () {
      this.onerror = null;
      this.onload = null;
      resolve();
    };
    script.onerror = function () {
      this.onerror = null;
      this.onload = null;
      reject(new Error(`Could not load ${script}`));
    };
  });

const ieOnEnd = script =>
  new Promise(resolve => {
    script.onreadystatechange = () => {
      if (this.readyState !== 'complete' && this.readyState !== 'loaded') {
        return;
      }
      this.onreadystatechange = null;
      resolve();
    };
  });

const loadScript = src => {
  const head = document.head || document.getElementsByTagName('head')[0];
  const script = document.createElement('script');

  script.type = 'text/javascript';
  script.src = src;

  const onEnd = 'onload' in script ? standardOnEnd : ieOnEnd;

  const promiseBody = (resolve, reject) =>
    onEnd(script)
      .then(() => resolve(script))
      .catch(() => {
        reject({
          message: `Failed to load ${script.src}`,
          hint: 'Check if the script URL is valid',
        });
      });

  return new Promise((resolve, reject) => {
    promiseBody(resolve, reject);

    if (!script.onload) {
      promiseBody(resolve, reject);
    }
    head.appendChild(script);
  });
};

export default loadScript;
